export var _labelTheme = {
  baseStyle: {
    label: {
      textStyle: 'body4Semi',
      color: 'neutral.darker',
      _invalid: {
        color: 'critical.main'
      },
      '&[data-view-mode="true"]': {
        pointerEvents: 'none'
      },
      _disabled: {
        color: 'neutral.light'
      }
    },
    description: {
      marginStart: 'xxs',
      textStyle: 'body4',
      color: 'neutral.darker',
      _invalid: {
        color: 'critical.main'
      },
      _disabled: {
        color: 'neutral.light'
      }
    },
    iconIndicator: {
      display: 'inline-flex',
      color: 'neutral.darker',
      _disabled: {
        color: 'neutral.light'
      }
    }
  }
};
//# sourceMappingURL=_Label.theme.js.map